module.exports = "/_next/static/images/1b083c4cf03f70e95f744ff3f90f0e91-mulher-com-cachos-maravilhosos-segurando-cartao-md@2x.jpg.webp";